<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [style]="{width: '40%'}"
  [draggable]="false"
  [resizable]="false"
  (onHide)="onHide()"
  [closeOnEscape]="true"
  [closable]="true"
  styleClass="p-dialog-carica-allegato">
  <ng-template pTemplate="header">
    <div class="dialog-header" style="padding: 0.5rem; display: flex; align-items: center; justify-content: space-between;">
      <div style="display: flex; align-items: center;">
        <h2 style="font-size: 1.2rem; margin: 0;">Carica {{ tipoAllegato === 'pdf' ? 'PDF' : 'Excel' }} per la scheda</h2>
        <div class="code-badge" style="background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem;">
          <span class="code-value" style="font-weight: bold; color: #3a6e75;">{{ scheda?.codice }}</span>
        </div>

      </div>
    </div>
  </ng-template>

  <div class="carica-allegato-container">
    <div *ngIf="(tipoAllegato === 'pdf' && scheda?.pdfCaricato) || (tipoAllegato === 'xls' && scheda?.xlsCaricato)"
         class="warning-message">
      <div class="warning-content">
        <div class="warning-icon">
          <i class="pi pi-exclamation-circle"></i>
        </div>
        <div class="warning-text">
          <h4>Attenzione</h4>
          <p>Stai per sovrascrivere il file {{ tipoAllegato === 'pdf' ? 'PDF' : 'Excel' }} precedentemente caricato.</p>
        </div>
      </div>
    </div>

    <div class="card-upload">
      <div *ngIf="isUploading" class="loading-container" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; display: flex; align-items: center; justify-content: center; background-color: rgba(255,255,255,0.9); z-index: 1000;">
        <ng-lottie [options]="options" ></ng-lottie>
      </div>
      <div *ngIf="!file">
        <p-fileUpload
          #fileUpload
          mode="basic"
          [chooseLabel]="'Seleziona ' + (tipoAllegato === 'pdf' ? 'PDF' : 'Excel')"
          [accept]="tipoAllegato === 'pdf' ? '.pdf' : '.xls,.xlsx'"
          [maxFileSize]="10000000"
          [auto]="false"
          [disabled]="isUploading"
          [style]="{'width':'100%'}"
          styleClass="p-button-outlined p-button-primary upload-button"
          (onSelect)="onFileSelect($event)"
          (onClear)="onClear()">
        </p-fileUpload>
      </div>

      <div *ngIf="file" class="file-info mt-3">
        <i class="pi" [ngClass]="tipoAllegato === 'pdf' ? 'pi-file-pdf' : 'pi-file-excel'" style="font-size: 1.5rem; color: #245358;"></i>
        <div class="file-details">
          <span class="file-name">{{ file.name }}</span>
          <span class="file-size">{{ (file.size / 1024 / 1024).toFixed(2) }} MB</span>
        </div>

        <button
          *ngIf="!isUploading"
          pButton
          type="button"
          icon="pi pi-times"
          class="p-button-rounded p-button-text p-button-danger ml-auto"
          (click)="onClear()"
          pTooltip="Rimuovi file">
        </button>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <p-button
        label="Annulla"
        icon="pi pi-times"
        styleClass="p-button-outlined p-button-secondary"
        [disabled]="isUploading"
        (click)="onHide()">
      </p-button>
      <p-button
        label="Carica"
        icon="pi pi-upload"
        [style]="{'background-color': '#245358', 'border-color': '#245358'}"

        [loading]="isUploading"
        [disabled]="!file || isUploading"
        (click)="caricaAllegato()">
      </p-button>
    </div>
  </ng-template>
</p-dialog>

<p-toast position="top-right"></p-toast>
